<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <main class="main-box">
            <section class="banner-img-bg layer-img-1">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <div class="banner-img-bg-content-wrapper">
                                <h1 class="banner-img-bg-title banner-img-bg-title_small">{{$t('meta.benefits.h1')}}</h1>
                                <h2 class="banner-img-bg-title banner-img-bg-title_default">{{$t('public.benefits.banner1_text')}}</h2>
                                <div class="button-wrapper">
                                    <button class="btn btn-link"><i class="icon-double-angle-down"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-2">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="banner-2-article-block bg-white pl-150">
                                <div class="banner-2-article-block-title">{{$t('public.benefits.block1.title')}}</div>
                                <div class="banner-2-article-block-content">{{$t('public.benefits.block1.text')}}</div>
                                <img class="bg-icon" src="~img/bg-icon-1-section-2.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')">
                            </div>
                            <div class="banner-2-article-block pl-150 mt-60">
                                <div class="banner-2-article-block-title">{{$t('public.benefits.block2.title')}}</div>
                                <div class="banner-2-article-block-content">{{$t('public.benefits.block2.text')}}</div>
                                <img class="bg-icon-left" src="~img/bg-icon-3-section-2.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')">
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="banner-2-article-block bg-white mt-280">
                                <div class="banner-2-article-block-title">{{$t('public.benefits.block3.title')}}</div>
                                <div class="banner-2-article-block-content">{{$t('public.benefits.block3.text')}}</div>
                                <img class="bg-icon-rigth" src="~img/bg-icon-2-section-2.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-3 bg-white">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-8">
                            <div class="banner-3-article-block bg-white">
                                <div class="banner-3-article-block-title-lg">{{$t('public.benefits.block_graph.title')}}</div>
                                <div class="banner-3-article-block-title">{{$t('public.benefits.block_graph.subtitle')}}</div>
                                <div class="banner-3-article-block-content">{{$t('public.benefits.block_graph.text')}}</div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="chart-container">
                                <div class="chart-container-col" style="height: 70%;">
                                    <div class="chart-col-header"><span>3</span><span>{{$t('public.benefits.block_graph.grahps[0].period')}}</span></div>
                                    <div class="chart-col-body"></div>
                                    <div class="chart-col-footer" v-html="$t('public.benefits.block_graph.grahps[0].per_time')"></div>
                                </div>
                                <div class="chart-container-col" style="height: 85%;">
                                    <div class="chart-col-header"><span>15</span><span>{{$t('public.benefits.block_graph.grahps[1].period')}}</span></div>
                                    <div class="chart-col-body"></div>
                                    <div class="chart-col-footer" v-html="$t('public.benefits.block_graph.grahps[1].per_time')"></div>
                                </div>
                                <div class="chart-container-col" style="height: 100%;">
                                    <div class="chart-col-header"><span>7</span><span>{{$t('public.benefits.block_graph.grahps[2].period')}}</span></div>
                                    <div class="chart-col-body"></div>
                                    <div class="chart-col-footer" v-html="$t('public.benefits.block_graph.grahps[2].per_time')"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-img-bg layer-img-2">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8">
                            <div class="banner-img-bg-content-wrapper">
                                <span class="banner-img-bg-title banner-img-bg-title_small">{{$t('public.benefits.banner2.label')}}</span>
                                <h2 class="banner-img-bg-title banner-img-bg-title_default">{{$t('public.benefits.banner2.title')}}</h2>
                                <div class="banner-img-bg-title banner-img-bg-title_medium">{{$t('public.benefits.banner2.text')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-5">
                <div class="container">
                    <div class="banner-5-title">{{$t('public.benefits.after_banner2_title')}}</div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="banner-5-article-block bg-white pl-150">
                                <div class="banner-5-article-block-title">{{$t('public.benefits.block4.title')}}</div>
                                <div class="banner-5-article-block-content">{{$t('public.benefits.block4.text')}}</div>
                                <div class="banner-5-article-block-footer">
                                    <ul class="nav">
                                        <li class="nav-item">
                                            <router-link tag="a" class="nav-link" :to="{name: 'Integration'}"><img src="~img/brand/amazon.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')"></router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link tag="a" class="nav-link" :to="{name: 'Integration'}"><img src="~img/brand/ebay.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')"></router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link tag="a" class="nav-link" :to="{name: 'Integration'}"><img src="~img/brand/shopify.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')"></router-link>
                                        </li>
                                    </ul>
                                </div>
                                <img class="bg-icon" src="~img/bg-icon-1-section-5.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')">
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="banner-5-article-block pr-125">
                                <div class="banner-5-article-block-title">{{$t('public.benefits.block5.title')}}</div>
                                <div class="banner-5-article-block-content">{{$t('public.benefits.block5.text')}}</div>
                                <img class="bg-icon-rigth" src="~img/bg-icon-2-section-5.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')">
                            </div>
                        </div>
                        <div class="col-lg-10">
                            <div class="banner-5-article-block pl-198">
                                <div class="banner-5-article-block-title">{{$t('public.benefits.block6.title')}}</div>
                                <div class="banner-5-article-block-content">{{$t('public.benefits.block6.text')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-6 bg-white">
                <div class="container">
                    <div class="row">
                        <div class="col-md-10 offset-md-2">
                            <h2 class="banner-6-title">{{$t('public.benefits.before_block7_title')}}</h2>
                        </div>
                        <div class="col-md-11">
                            <div class="banner-6-article-block pl-150">
                                <div class="banner-6-article-block-title">{{$t('public.benefits.block7.title')}}</div>
                                <div class="banner-6-article-block-content">{{$t('public.benefits.block7.text')}}</div>
                                <div class="banner-6-article-block-footer">
                                    <ul class="nav">
                                        <li class="nav-item pr-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners7.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners19.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners16.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners14.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners15.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners10.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners18.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners17.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                        <li class="nav-item px-3">
                                            <router-link tag="a" :to="{name:'Partnerial'}"><img src="~img/partners20.png" :alt="$t('meta.partners.h1')"  :title="$t('meta.partners.h1')"></router-link>
                                        </li>
                                    </ul>
                                </div>
                                <img class="bg-icon" src="~img/bg-icon-1-section-2.png" :alt="$t('meta.benefits.h1')"  :title="$t('meta.benefits.h1')">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="banner-img-bg layer-img-3">
                <div class="container">
                    <div class="banner-img-bg-content-wrapper">
                        <div class="row">
                            <div class="col-lg-6">
                                <h2 class="banner-img-bg-title banner-img-bg-title_default">{{$t('public.benefits.banner3.title')}}</h2>
                                <div class="banner-img-bg-title banner-img-bg-title_medium">{{$t('public.benefits.banner3.text')}}</div>
                                <div class="button-wrapper">
                                    <router-link tag="button" class="btn btn-accent" :to="{name: 'register'}">{{$t('public.benefits.banner3.btn')}}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main><!-- End Main -->

        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'Advantages',
        beforeRouteEnter(from, to, next) {
            next((vm) => vm.$store.dispatch('changeStylesSpecialPage', 'advantages'))
        },
        beforeRouteLeave(from, to, next) {
            this.$store.dispatch('changeStylesSpecialPage', '').then(() => next())
        },
        metaInfo() {
            return {
                title: this.$t('meta.benefits.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.benefits.description') },
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/Advantages.vue